import { render, staticRenderFns } from "./ViewEstablishmentInternalOrderPage.vue?vue&type=template&id=4013fd5b"
import script from "./ViewEstablishmentInternalOrderPage.vue?vue&type=script&lang=js"
export * from "./ViewEstablishmentInternalOrderPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports